import { render } from "./reduction_users.vue?vue&type=template&id=595f8b48"
import script from "./reduction_users.vue?vue&type=script&lang=js"
export * from "./reduction_users.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/comerc/reduction_users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "595f8b48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('595f8b48', __exports__)) {
    console.log('reload')
    api.reload('595f8b48', __exports__)
  }
  
  module.hot.accept("./reduction_users.vue?vue&type=template&id=595f8b48", () => {
    console.log('re-render')
    api.rerender('595f8b48', render)
  })

}


export default __exports__